<template>
  <div class="container">
    <div>
      <div class="header">
        <div class="profile-box">
          <img :src="user.avatar" alt />
        </div>
        <div class="nickFile">
          <p class="text1">Hi,{{ user.nickName }}</p>
        </div>
      </div>
      <div class="center-box">
        <div class="ranking-box">
          <p>老师您好:</p>
          <p
            class="text"
            v-if="dataInfo.status == null || dataInfo.status == 2"
          >
            您的会员将于{{ dataInfo.expirationTime }}到期,请上传您的续费缴费凭证
          </p>
          <p class="text" v-if="dataInfo.status == 0">
            您的续费申请已经提交，请留意短信的续费审核通知！
          </p>
          <p class="text" v-if="dataInfo.status == 1">
            您的申请已通过，请留意短信的续费审核通知！
          </p>
        </div>
      </div>
      <div class="form">
        <div class="rolItems">
          <mt-field
            label="手机号："
            class="inputTxt"
            type="text"
            v-model="dataInfo.mobile"
            placeholder="请输入收件人手机号"
            disabled
          ></mt-field>
        </div>
        <div class="rolItem">
          <span>缴费凭证:</span>
          <div>
            <SignUpload
              v-on:avatarInput="formUrl"
              class="upload"
              title="上传缴费凭证"
              name="renewalImg"
              :imgList="dataInfo.renewalImg || ''"
              :disabled="[0, 1].indexOf(dataInfo.status) != -1"
            />
          </div>
        </div>
        <div class="rolItems">
          <mt-field label="是否开发票：" class="inputStyle">
            <input
              type="radio"
              id="normal"
              :value="1"
              v-model="dataInfo.isInvoice"
              :disabled="[0, 1].indexOf(dataInfo.status) != -1"
            />是
            <input
              type="radio"
              id="doctor"
              :value="0"
              v-model="dataInfo.isInvoice"
              :disabled="[0, 1].indexOf(dataInfo.status) != -1"
            />否
          </mt-field>
        </div>
        <div class="rolItems" v-if="dataInfo.isInvoice == 1">
          <mt-field
            label="发票抬头："
            class="inputTxt"
            type="text"
            v-model="dataInfo.invoiceTitle"
            placeholder="请输入发票抬头"
            :disabled="[0, 1].indexOf(dataInfo.status) != -1"
          ></mt-field>
        </div>
        <div class="rolItems" v-if="dataInfo.isInvoice == 1">
          <mt-field
            label="税号："
            class="inputTxt"
            type="text"
            v-model="dataInfo.dutyParagraph"
            placeholder="请输入税号"
            :disabled="[0, 1].indexOf(dataInfo.status) != -1"
          ></mt-field>
        </div>
        <div class="rolItems" v-if="dataInfo.isInvoice == 1">
          <mt-field
            label="收件人："
            class="inputTxt"
            type="text"
            v-model="dataInfo.recipients"
            placeholder="请输入收件人"
            :disabled="[0, 1].indexOf(dataInfo.status) != -1"
          ></mt-field>
        </div>
        <div class="rolItems" v-if="dataInfo.isInvoice == 1">
          <mt-field
            label="收件地址："
            class="inputTxt"
            type="text"
            v-model="dataInfo.recipientAddress"
            placeholder="请输入收件地址"
            :disabled="[0, 1].indexOf(dataInfo.status) != -1"
          ></mt-field>
        </div>
      </div>
      <div class="getBtn">
        <mt-button type="primary" class="btn" v-if="dataInfo.status == 0">
          待审核</mt-button
        >
        <mt-button type="primary" class="btn" v-else-if="dataInfo.status == 1">
          审核已通过</mt-button
        >
        <mt-button type="primary" class="btn" @click="submit" v-else>
          {{ dataInfo.status == null ? '提交' : '提交' }}</mt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import SignUpload from '../../components/SignUpload.vue'
import { videoShare } from '@/common/wxshare'
export default {
  components: { SignUpload },
  name: 'Record',
  data() {
    return {
      dataInfo: {
        renewalImg: '',
        isInvoice: 0,
        mobile: '',
        recipients: '',
        dutyParagraph: '',
        invoiceTitle: '',
        recipientAddress: '',
      },
      user: {},
      isLoading: false,
    }
  },
  created() {},
  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.getDetail()
  },
  methods: {
    refresh() {
      location.reload()
    },
    //   审核详情查询
    getDetail() {
      this.$http({
        url: `/xhRenewal/getInfoByOpenId/${sessionStorage.getItem('openId')}`,
        method: 'get',
      }).then(({ data }) => {
        this.isLoading = false
        if (data.data && data.code === 0) {
          this.dataInfo = data.data
          if (!this.dataInfo.isInvoice) {
            this.dataInfo.isInvoice = 0
          }
          if (data.data.status == 1) {
            this.$toast('续费审核已通过，请留意短信的续费审核通知')
          }
          if (data.data.status == 2) {
            this.$toast('续费审核被驳回，请重新提交')
          }
        }
      })
    },
    // 获取上传地址
    formUrl(url, name) {
      this.dataInfo[name] = url
    },
    // 提交认证信息
    submit() {
      if (!this.dataInfo.renewalImg) {
        this.$toast('缴费凭证不能为空')
        return this
      }
      if (!this.dataInfo.invoiceTitle && this.dataInfo.isInvoice == 1) {
        this.$toast('发票抬头不能为空')
        return this
      }
      if (!this.dataInfo.dutyParagraph && this.dataInfo.isInvoice == 1) {
        this.$toast('税号不能为空')
        return this
      }
      if (!this.dataInfo.recipients && this.dataInfo.isInvoice == 1) {
        this.$toast('收件人不能为空')
        return this
      }
      if (!this.dataInfo.mobile && this.dataInfo.isInvoice == 1) {
        this.$toast('收件人手机号不能为空')
        return this
      }
      if (!this.dataInfo.recipientAddress && this.dataInfo.isInvoice == 1) {
        this.$toast('收件地址不能为空')
        return this
      }
      let mreg = /^1[0-9]{10}$/
      if (!mreg.test(this.dataInfo.mobile) && this.dataInfo.isInvoice == 1) {
        this.$toast('请输入正确的手机号')
        return this
      }
      this.$http({
        url: '/xhRenewal/saveOrUpdateMember',
        method: 'post',
        data: { ...this.dataInfo, openId: sessionStorage.getItem('openId') },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.$toast('申请已提交,请留意短信的续费审核通知')
          this.getDetail()
        } else {
          this.$toast(data.msg)
        }
      })
    },
    wxShare() {
      //分享
      let shareTitle = '续费申请'
      let shareUrl = location.href
      let shareImg =
        'https://m-live-bucket.oss-cn-beijing.aliyuncs.com/2020/08/06/cc5bca97-89a8-46eb-8fd7-8f6c7c0f7ed0_f97d247b94aa981b37e164ff2f57b34.png'
      let shareDesc = '续费申请'
      videoShare(this, shareTitle, shareUrl, shareImg, shareDesc)
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  .questionHeader {
    padding: 2rem;
    font-size: 20px;
    margin-bottom: 80px;
    span {
      padding-left: 20px;
    }
    img {
      width: 48px;
    }
  }
  .questionStatus {
    text-align: center;
    font-size: 20px;
    padding: 30px 10px;
    margin: 1rem;
    p {
      margin-top: 20px;
      font-size: 16px;
    }
    img {
      width: 48px;
    }
  }
  .header {
    height: 18rem;
    background: url(../../assets/img/timg.jpg) no-repeat;
    position: relative;
    box-sizing: border-box;
    padding: 10px;
    color: #566079;
    .profile-box {
      width: 6rem;
      height: 6rem;
      border: 2px solid #ffffff;
      border-radius: 50%;
      float: left;
      margin: 2rem 0.4rem 0 1rem;
      img {
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 50%;
      }
    }
    .nickFile {
      position: absolute;
      left: 85px;
      margin: 2rem 0.4rem 0 1rem;
      .text1 {
        font-size: 22px;
        line-height: 70px;
      }
      .text2 {
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }
  .center-box {
    height: 9rem;
    background: #e8e8e8;
    position: relative;
    padding: 0 10px;
    box-sizing: border-box;
    .ranking-box {
      padding: 10px;
      position: absolute;
      background: #fff;
      line-height: 30px;
      top: -4rem;
      left: 10px;
      right: 10px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(255, 255, 255, 0.7);
    }
    .text {
      text-indent: 2em;
    }
  }
  .form {
    .rolItem {
      padding: 1rem;
    }
  }
  .getBtn {
    box-sizing: border-box;
    margin-top: 20px;
    height: 55px;
    padding: 0 1rem;
    padding-bottom: 1rem;
    width: 100%;
    background-color: #fff;
    text-align: center;
  }
  .btn {
    width: 90%;
    height: 100%;
    font-size: $font-title;
    border-radius: 10px;
    line-height: 36px;
  }
  .btn:hover {
    color: #fff;
    text-decoration: none;
    border: none;
  }
  .btn:focus,
  .btn.focus {
    outline: 0;
    box-shadow: none;
  }
  .down_a {
    color: #f5a323 !important;
  }
  .inputStyle /deep/ .mint-field-core {
    flex: 0;
    padding: 0;
    width: 0;
  }
  .rolItems {
    background-color: #eee;
    padding-bottom: 1rem;
  }
}
</style>
